module.exports = __webpack_public_path__ + "img/footer-bili.9ffc6193.png";